import { authHeader } from '../helpers/auth-header';

const fetchBannersType = 'FETCH_BANNERS';
const getBannersType = 'GET_BANNERS';
const postBannerType = 'POST_BANNER';
const getBannerType = 'GET_BANNER';
const putBannerType = 'PUT_BANNER';
const deleteBannerType = 'DELETE_BANNER';
const checkBannerType = 'CHECK_BANNER';

const initialState = { banners: [], banner: null, isLoading: false };

export const bannersActions = {

    getBanners: (c, s) => async (dispatch, getState) => {
        dispatch({ type: fetchBannersType });
        const response = await fetch(`api/banners?c=${c}&s=${s}`);
        const banners = await response.json();
        dispatch({ type: getBannersType, banners });
    },

    postBanner: banner => async (dispatch, getState) => {
        var formData = new FormData();
        for (let key in banner) {
            formData.append(key, banner[key]);
        }
        await fetch(`api/banners`, {
            method: 'POST',
            headers: authHeader(),
            body: formData
        })
    },

    getBanner: id => async (dispatch, getState) => {
        const response = await fetch(`api/banners/${id}`);
        const body = await response.body();
        console.log(body);
        //const board = await response.json();
        //dispatch({ type: getBoardType, board });
    },

    putBanner: (id, banner) => async (dispatch, getState) => {
        var formData = new FormData();
        for (var key in banner) {
            //console.log(key +" : "+ banner[key]);
            formData.append(key, banner[key]);
        }
        await fetch(`api/banners/${id}`, {
            method: 'PUT',
            headers: authHeader(),
            body: formData
        })
    },

    deleteBanner: bannerId => async (dispatch, getState) => {
        dispatch({ type: fetchBannersType });
        const response = await fetch(`api/banners/${bannerId}` , {
            method: 'DELETE',
            headers: authHeader()
        })
        bannerId = await response.json();
        dispatch({ type: deleteBannerType, bannerId });
    },

    checkBanner: (id) => async (dispatch, getState) => {
        dispatch({ type: fetchBannersType });
        const response = await fetch(`api/banners/checkbox/${id}`, {
            method: 'PUT',
            headers: authHeader(),
            //headers: { 'Content-Type': 'application/json' },
        })
        const banner = await response.json();
        dispatch({ type: checkBannerType, banner });
    }
};

export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case fetchBannersType:
            return { ...state, isLoading: true };

        case getBannersType:
            return { ...state, banners: action.banners, isLoading: false };

        case postBannerType:
            return { ...state, banner: action.banner };

        case getBannerType:
            return { ...state, banner: action.banner };

        case putBannerType:
            return { ...state, bannerId: action.bannerId, banner: action.banner };

        case deleteBannerType:
            return { ...state, banners: state.banners.filter(banner => banner.bannerId !== action.bannerId), isLoading: false };

        case checkBannerType:
            let { banners } = state;
            for (let i = 0; i < banners.length; i++) {
                let banner = banners[i];
                if (banner.bannerId === action.banner.bannerId) {
                    banners[i].enabled = action.banner.enabled;
                }
            }
            return { ...state, banners: banners, isLoading: false };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/store/banners.js